import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { MasterDataUrl } from '../../../shared/urls/master-data.urls';
import { PatientUrl } from '../../../shared/urls/patient.url';
import { ConsultationUrl } from '../../../shared/urls/consultation.url';
import { PreviousVaccineModel } from '../../../models/consultation-process/previous-vaccine.model';
import { Utility } from '../../../common/utility';
@Injectable()
export class PreviousVaccineService {
    constructor(public baseService: BaseService) {

    }

    getDisease() {
        const url = MasterDataUrl.GET_DISEASE_DROPDOWN_LIST;
        return this.baseService.getData(url, { isVaccineFilter: true });
    }

    getVaccineByDiseaseId(diseaseId) {
        const url = MasterDataUrl.GET_VACCINE_BY_DISEASE.replace("{id}", diseaseId);
        return this.baseService.getData(url);
    }
    getVaccineList(userId, param) {
        const url = PatientUrl.GET_PATIENT_PREVIOUS_VACCINE.replace("{id}", userId);
        return this.baseService.getData(url, param);
    }

    getOtherCentre() {
        const url = MasterDataUrl.GET_OTHER_CENTRES;
        return this.baseService.getData(url);
    }

    updatePreviousVaccine(consultationId, userId, data) {
        const url = Utility.stringFormat(ConsultationUrl.ADD_PREVIOUS_VACCINE, [consultationId, userId]);
        return this.baseService.postData(url, data);
    }

    removePreviousVaccine(consultationId, patientOtherVaccineId) {
        const url = ConsultationUrl.REMOVE_PATIENT_OTHER_VACCINE
            .replace("{consultationId}", consultationId)
            .replace("{patientOtherVaccineId}", patientOtherVaccineId);
        return this.baseService.delete(url);
    }
}

// const dataList: Array<PreviousVaccineModel> = [
//     {
//         'id': 'VC001',
//         'name': 'Boostrix 1 - Tentanus/Diptheria/Pertussis',
//         'administeredDateTimestamp': 1474268555,
//         'expireDateTimestamp': 1537340555,
//         'monthCoverLeft': 11,
//         'centre': 'Biomis Lab',
//         'batchNo': '001'
//     },
//     {
//         'id': 'VC002',
//         'name': 'SBoostrix 2 - Tentanus/Diptheria/Pertussis',
//         'administeredDateTimestamp': 1474268555,
//         'expireDateTimestamp': 1537340555,
//         'monthCoverLeft': 11,
//         'centre': 'Biomis Lab',
//         'batchNo': '002'
//     },
//     {
//         'id': 'VC003',
//         'name': 'ABoostrix 3 - Tentanus/Diptheria/Pertussis',
//         'administeredDateTimestamp': 1474268555,
//         'expireDateTimestamp': 1537340555,
//         'monthCoverLeft': 11,
//         'centre': 'Biomis Lab',
//         'batchNo': '003'
//     }
// ];


// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/record-previous-vaccines/record-previous-vaccine.service.ts